/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Initialization } from '../../models/initialization';

export interface GetInitializationByUserId$Params {
}

export function getInitializationByUserId(http: HttpClient, rootUrl: string, params?: GetInitializationByUserId$Params, context?: HttpContext): Observable<StrictHttpResponse<Initialization>> {
  const rb = new RequestBuilder(rootUrl, getInitializationByUserId.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Initialization>;
    })
  );
}

getInitializationByUserId.PATH = '/api/mh/initialization';
